import { useConfirmationDialog, UseConfirmationDialogOpts } from '@lbcamden/lib-react';

type DialogActions = Pick<UseConfirmationDialogOpts, 'onConfirm' | 'onCancel'>;

type Options = {
  sectionNavActions: DialogActions;
  finishActions: DialogActions;
  submitActions: DialogActions;
  approveActions: DialogActions;
  hasSubmitted?: boolean;
};

export const usePcfraConfirmationDialogs = ({
  sectionNavActions,
  finishActions,
  submitActions,
  approveActions,
  hasSubmitted,
}: Options) => {
  const sectionNavDialog = useConfirmationDialog({
    title: 'Section incomplete',
    message:
      'This section has one or more incomplete fields. Are you sure you want to leave? ' +
      'The current values have been saved and can be completed later.',
    confirmLabel: 'Leave section',
    cancelLabel: 'View incomplete fields',
    ...sectionNavActions,
  });

  const finishDialog = useConfirmationDialog({
    title: 'PCFRA incomplete',
    message:
      'One or more sections have incomplete fields. Are you sure you want to finish? ' +
      'The current values have been saved and can be completed later.',
    confirmLabel: 'Finish editing',
    cancelLabel: 'View incomplete sections',
    ...finishActions,
  });

  const submitDialog = useConfirmationDialog({
    title: 'PCFRA complete',
    message:
      (hasSubmitted
        ? 'This PCFRA has been completed and submitted for approval. Do you want to resend the submission email?'
        : 'All PCFRA sections have been completed. Do you want to submit for approval? ') +
      (hasSubmitted ? '' : 'The current values have been saved and can be submitted later.'),
    confirmLabel: hasSubmitted ? 'Resend submission email' : 'Submit for approval',
    cancelLabel: hasSubmitted ? 'Finish' : 'Finish without submission',
    confirmButtonProps: { $color: 'dartmouthGreen' },
    cancelButtonProps: { $variant: 'primary' },
    ...submitActions,
  });

  const approveDialog = useConfirmationDialog({
    title: 'PCFRA approval',
    message: 'This PCFRA is complete. Do you want to approve it?',
    confirmLabel: 'Approve',
    cancelLabel: 'Exit without approving',
    confirmButtonProps: { $color: 'dartmouthGreen' },
    cancelButtonProps: { $variant: 'primary' },
    ...approveActions,
  });

  return { sectionNavDialog, finishDialog, submitDialog, approveDialog };
};
